import React from 'react';
import PlayerPage from '../components/PlayerPage';

class Osh extends React.Component {
  //Create props for specific client page
  constructor(props) {
    super(props);
    this.state = {
      switchTagline: true,
      switchButton: true,
      switchPlayer: false
    };

    this.name = 'fulham';
    this.background = require('../img/' + this.name + '/background.jpg');
    this.backgroundType = 'image';
    this.logo = require('../img/' + this.name + '/logo.png');
    //this.playerID = '139.751'; //used for local testing
    this.playerID = '433.092'; // for streamline.soluis.com

  }

  //Create content for the tagline section
  renderTagline() {
    return (
      <>
        <p>Fulham FC Stadium:</p>
        <h1>Explore using Streamline</h1>
      </>
    )
  }

  render() {
    return (
      <PlayerPage name={this.name} background={this.background.default} backgroundType={this.backgroundType} logo={this.logo.default} tagline={this.renderTagline()} playerid={this.playerID} />
    );
  }
}

export default Osh;

